import { createContext, useEffect, useState } from "react";
import Loading from "../components/Loading";
import { useLocation } from "react-router";

const defaultValues = {
  loading: false,
};

const RequestContext = createContext(defaultValues);

const RequestProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);

  const location = useLocation();

  useEffect(() => {
    if (loading) {
      document.body.style.overflow = "hidden";
    }

    return () => {
      document.body.style.overflow = "unset";
    };
  }, [loading]);

  const setRequestLoading = (value) => {
    setLoading(value);
  };

  useEffect(() => {
    if (loading) {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  return (
    <RequestContext.Provider
      value={{ setRequestLoading, requestLoading: loading }}
    >
      {loading && (
        <div className="form-loading position-fixed vw-100 vh-100 bg-light bg-opacity-75 d-flex justify-content-center align-items-center">
          <Loading />
        </div>
      )}
      {children}
    </RequestContext.Provider>
  );
};

export { RequestContext, RequestProvider };
